// Set formats only for results
const setFixedNumber = (dataFormat) => +Math.round(dataFormat.toFixed(2));

// default global const
const MONTH_IN_YEAR = 12;
const LOAN_POSITIVE = 80;
const PERCENT_BASE = 100;

/*-*/
const getYearResult = (monthlyRentNew) => monthlyRentNew * MONTH_IN_YEAR;

const getMonthlyResult = (monthlyRentNew, annualRentIncrease) => {
  const result = (monthlyRentNew * annualRentIncrease) / PERCENT_BASE;
  return result + monthlyRentNew;
};
/*-*/

/*-*/
const getTaxesInsuranceBuy = (annualTaxIncreaseResult, annualInsuranceResult, yearsBefore) => {
  const resultInsurance = annualInsuranceResult * yearsBefore;
  // if increase
  // const resultTaxes = annualTaxIncreaseResult;
  const resultTaxes = annualTaxIncreaseResult;
  // console.log(resultTaxes)
  const result = resultInsurance + resultTaxes;
  // console.log(result)
  return +result;
};
/*-*/

/*-*/
const getRentInsurance = (MONTHLY_RENT, RENT_INSURANCE, yearsBefore, SWITCH_RENTAL_INSURANCE) => {
  if (SWITCH_RENTAL_INSURANCE === '$') {
    const result = (RENT_INSURANCE * 12) * yearsBefore;
    return +result;
  }
  const result = (MONTHLY_RENT * (RENT_INSURANCE / PERCENT_BASE) * 12) * yearsBefore;
  return +result;
};
/*-*/

/*-*/
// const getPrincipalRent = (MONTHLY_RENT, RENT_INSURANCE, yearsBefore, SWITCH_RENTAL_INSURANCE) => {
//   if (SWITCH_RENTAL_INSURANCE === '$') {
//     const result = (MONTHLY_RENT * 12);
//     return +result;
//   }
//   const result = (MONTHLY_RENT * (RENT_INSURANCE / PERCENT_BASE) * 12) * yearsBefore;
//   return +result;
// };

const getPrincipalRent = (yearsBefore, monthlyRent, annualRentIncrease) => {
  let countMonth = 0;
  let lastYear = 0;
  let monthlyRentNew = monthlyRent;
  let yearResult = getYearResult(monthlyRentNew);
  while (countMonth < yearsBefore) {
    countMonth += 1;
    yearResult = getYearResult(monthlyRentNew);
    monthlyRentNew = getMonthlyResult(monthlyRentNew, annualRentIncrease);
    lastYear = yearResult + lastYear;
  }

  return +lastYear;
};
/*-*/
/*-*/
const getPrincipalBuy = (totalPaymentsBuyResult, taxesInsuranceBuyResult, PMIBuyResult, maintenanceBuyResult) => {
  const result = totalPaymentsBuyResult - (taxesInsuranceBuyResult + PMIBuyResult + maintenanceBuyResult);
  return +result;
};
/*-*/

/*-*/
const getAnnualTax = (annualTax, switchTaxes, homeValue) => {
  if (switchTaxes === '$') {
    return +annualTax;
  }
  const result = homeValue * (annualTax / PERCENT_BASE);

  return +result;
};
/*-*/

const getTaxesIfAppreciationValue = (homeValue, yearsBefore, annualAppreciation) => {
  if (homeValue !== 0) {
    let newValue = 0;
    const annualAppreciationNew = annualAppreciation / PERCENT_BASE;
    let homeValueNew = homeValue;
    let counter = 0;
    while (counter < yearsBefore) {
      counter += 1;
      newValue = getNewValue(homeValueNew, annualAppreciationNew);
      homeValueNew += newValue;
    }
    return +homeValueNew;
  }
  return 0;
};
const getAnnualTaxIncrease = (ANNUAL_TAX, SWITCH_TAXES, HOME_VALUE, YEARS_BEFORE, ANNUAL_APPRECIATION)  => {
  let annualTaxIncrease =  ANNUAL_TAX;
  if (SWITCH_TAXES === '$') {
    return +annualTaxIncrease * YEARS_BEFORE;
  }
  if (HOME_VALUE !== 0) {
    let newTaxResult = 0;
    let totalTaxResult = 0;
    let newValue = 0;
    const annualAppreciationNew = ANNUAL_APPRECIATION / PERCENT_BASE;
    let homeValueNew = HOME_VALUE;
    let counter = 0;
    while (counter < YEARS_BEFORE) {
      counter += 1;
      newValue = getNewValue(homeValueNew, annualAppreciationNew);
      newTaxResult = homeValueNew * (ANNUAL_TAX / PERCENT_BASE);
      totalTaxResult = totalTaxResult + newTaxResult;
      homeValueNew += newValue;
      // console.log(homeValueNew)
    }
    return +totalTaxResult;
  }
  // if increase
  // let increaseNew = 0;
  // let resultIncrease;
  // let resultIncreaseLast = 0;
  // for(let i = 0; i < yearsBefore; i++){
  //   resultIncrease = homeValue * ((annualTaxIncrease + increaseNew) / PERCENT_BASE);
  //   increaseNew = increaseNew + increase;
  //   resultIncreaseLast = resultIncreaseLast + resultIncrease;
  // }
  // return +resultIncreaseLast;

  // const result = homeValue * (annualTaxIncrease / PERCENT_BASE);
  return +result;
};

const getAnnualInsurance = (annualInsurance, switchInsurance, homeValue) => {
  if (switchInsurance === '$') {
    return +annualInsurance;
  }
  const result = homeValue * (annualInsurance / PERCENT_BASE);
  return +result;
};

const getAnnualTaxRate = (yourTaxRate, switchTaxRate) => {
  if (switchTaxRate === '$') {
    return +yourTaxRate;
  }
  const result = yourTaxRate / PERCENT_BASE;
  return +result;
};
const getPoints = (SWITCH_POINTS, AMOUNT_RESULT, points) => {
  if (SWITCH_POINTS === '$') {
    return +points;
  }
  const result = (points / PERCENT_BASE) * AMOUNT_RESULT;
  return +result;
};

const getMaintenanceBuyResult = (annualAppreciation, HOA_DUES, yearsBefore) => {
  const result = (annualAppreciation + HOA_DUES) * yearsBefore;
  return +result;
};
/*-*/

const getInterestRateMonthly = (interestRate) => {
  const result = interestRate / PERCENT_BASE / MONTH_IN_YEAR;
  return +result;
};

const getResMonthlyPI = (amountResult, interestRateMonthlyResult, paymentsMonthResult) => {
  if (interestRateMonthlyResult !== 0) {
    const result = (amountResult * interestRateMonthlyResult * (1 + interestRateMonthlyResult) ** paymentsMonthResult)
      / ((1 + interestRateMonthlyResult) ** paymentsMonthResult - 1);

    return +result;
  }
  return 0;
};
const getResMonthlyPINew = (amountResult, interestRateMonthlyResult, paymentsMonthResult) => {
  if (interestRateMonthlyResult !== 0) {
    const result = (amountResult * interestRateMonthlyResult * (1 + interestRateMonthlyResult) ** paymentsMonthResult)
      / ((1 + interestRateMonthlyResult) ** paymentsMonthResult - 1);

    return +result;
  }
  return 0;
};

const getInterestNew = (amountResultNew, interestRateResult) => {
  if (interestRateResult !== 0) {
    const result = (amountResultNew * interestRateResult) / MONTH_IN_YEAR;
    return +result;
  }
  return 0;
};

const getResMonthlyInterest = (amountResult, interestRateResult) => {
  const result = (amountResult * interestRateResult) / MONTH_IN_YEAR;
  return +result;
};

const getInterestRate = (interestRate) => {
  const result = interestRate / PERCENT_BASE;
  return +result;
};


const getAnnualPMI = (annualPmi, switchPMI, amountResult) => {
  if (switchPMI === '$') {
    return +annualPmi;
  }
  const result = amountResult * (annualPmi / PERCENT_BASE);
  // console.log(result)
  return +result;
};

const getMonthlyPMI = (annualPMIResult, switchPMI, loanValueRatioResult, interestRateResult) => {
  if (interestRateResult !== 0 && loanValueRatioResult > LOAN_POSITIVE) {
    // console.log(+annualPMIResult)
    return +annualPMIResult / MONTH_IN_YEAR;
  }
  return 0;
};
/*-*/
const getValueRatio = (amountResult, homeValue) => {
  const result = (amountResult * PERCENT_BASE) / homeValue;
  return +result;
};

const getMonthlyTax = (annualTaxResult) => +annualTaxResult / MONTH_IN_YEAR;

const getMonthlyInsurance = (annualInsuranceResult) => +annualInsuranceResult / MONTH_IN_YEAR;

const getMonthPMI = (
  loanValueRatioResult,
  amountResult,
  homeValue,
  monthlyPIResult,
  monthlyInterestResult,
  monthlyPMIResult,
  paymentsMonthResult,
  interestRateResult,
) => {
  if (interestRateResult !== 0) {
    let countMonth = 0;
    let principalResNew = 0;
    let monthlyPINew = monthlyPIResult;
    let loanValueResNew = loanValueRatioResult;
    let amountResultNew = amountResult;

    while (loanValueResNew > LOAN_POSITIVE) {
      countMonth += 1;
      const interestRateMonthlyResultNew = getInterestNew(amountResultNew, interestRateResult);
      const interest = interestRateMonthlyResultNew ?? 0;

      principalResNew = monthlyPINew - interest;
      amountResultNew = amountResultNew - principalResNew;

      loanValueResNew = (amountResultNew * PERCENT_BASE) / homeValue;
      loanValueResNew = Math.floor(loanValueResNew * 10) / 10;
    }
    // console.log(countMonth)
    return countMonth;
  }
  return 0;
};

const getResMonthlyPayment = (
  amountResult,
  interestRateMonthlyResult,
  paymentsMonthResult,
  monthlyTaxResult,
  monthlyInsuranceResult,
  monthlyPMIResult,
) => {
  if (interestRateMonthlyResult !== 0) {
    const calcDetailsForMonthly = monthlyTaxResult + monthlyInsuranceResult + monthlyPMIResult;
    const result = (amountResult * interestRateMonthlyResult * (1 + interestRateMonthlyResult) ** paymentsMonthResult)
        / ((1 + interestRateMonthlyResult) ** paymentsMonthResult - 1)
      + calcDetailsForMonthly;

    return +result.toFixed(2);
  }

  return 0;
};
/*-*/

/*-*/
const getPMIBuy = (annualPMIResult, monthPMIResult, yearsBefore, amountResult, monthlyPIResult, interestRateResult, loanValueRatioResult, homeValue, paymentsMonthResult) => {
  let monthBeforeRes = yearsBefore * 12;
  let monthTotal = monthPMIResult;

  let pmiAsResult = annualPMIResult;
  let pmiMonthlyResult = annualPMIResult / 12;

  if (monthBeforeRes < monthTotal) {
    let monthBeforeResNew = 1;
    let principalResNew = 0;
    let pmiResNew = 0;
    let monthlyPINew = monthlyPIResult;
    let amountResultNew = amountResult;
    let interestRateMonthlyResultNew = interestRateResult;
    let total = 0;
    while (monthBeforeRes > monthBeforeResNew) {
      monthBeforeResNew += 1;
      total = total + pmiMonthlyResult;
    }

    return total;

  } else {
    let monthTotalRes = 0;
    let principalResNew = 0;
    let pmiResNew = 0;
    let monthlyPINew = monthlyPIResult;
    let amountResultNew = amountResult;
    let interestRateMonthlyResultNew = interestRateResult;
    let total = 0;
    while (monthTotalRes < monthPMIResult) {
      monthTotalRes += 1;
      // interestRateMonthlyResultNew = getInterestNew(amountResult, interestRateResult);
      // const interest = interestRateMonthlyResultNew / 12 ?? 0;
      //
      // principalResNew = monthlyPINew - interest;
      // pmiResNew = principalResNew + interestRateMonthlyResultNew;
      // amountResultNew = amountResultNew - principalResNew;

      total = total + pmiMonthlyResult;
      // console.log(total)
      // console.log(pmiMonthlyResult)

    }
    return total;
  }

  // const result = annualPMIResult * yearsBefore;
  // return +result;
};
/*-*/

/*-*/
const getDifferencePmi = (monthsTotal, monthPMIResult, monthlyPMIResult, YEARS_BEFORE) => {
  const result = (monthsTotal - monthPMIResult) * monthlyPMIResult;
  // console.log((monthsTotal - monthPMIResult) * monthlyPMIResult)
  return +result;
};
/*-*/

/*-*/
const getTotalRent = (yearsBefore, monthlyRent, annualRentIncrease, taxesInsuranceRentResult) => {
  let countMonth = 0;
  let lastYear = 0;
  let monthlyRentNew = monthlyRent;
  let yearResult = getYearResult(monthlyRentNew);

  // console.log(yearResult)
  while (countMonth < yearsBefore) {
    countMonth += 1;
    yearResult = getYearResult(monthlyRentNew);
    monthlyRentNew = getMonthlyResult(monthlyRentNew, annualRentIncrease);
    // console.log(monthlyRent)
    lastYear = yearResult + lastYear;
  }
  // console.log(lastYear)

  return +lastYear + taxesInsuranceRentResult;
};

const getTotalBuy = (monthlyPMIResult, monthlyPaymentResult, annualMaintenance, monthsTotal,  differenceWithoutPmi, monthPMIResult, taxesInsuranceBuyResult) => {
  // if(differenceWithoutPmi > 0){
  //   const totalMonthly = ((monthlyPaymentResult + (+annualMaintenance / 12)) * monthsTotal) - differenceWithoutPmi;
    // console.log((monthlyPaymentResult + (+annualMaintenance / 12)) * monthsTotal);
    // return +totalMonthly;
  // }
  // console.log(monthsTotal)
  // console.log(monthlyPMIResult)

  return ((monthlyPaymentResult + annualMaintenance / 12) * monthsTotal);

};
/*-*/

/*-*/
const getAverageMonthlyRent = (totalPaymentsRentResult, monthsTotal) => {
  if (totalPaymentsRentResult !== 0) {
    return +totalPaymentsRentResult / +monthsTotal;
  }
  return 0;
};

const getAverageMonthlyBuy = (totalPaymentsBuyResult, monthTotal) => {
    return +totalPaymentsBuyResult / monthTotal
};
/*-*/

/*-*/
const getMonthlyRentSavings = (averageMonthlyRentResult, averageMonthlyBuyResult) => {
  if (averageMonthlyRentResult !== 0) {
    const result = Math.abs(averageMonthlyRentResult - averageMonthlyBuyResult);
    return +result;
  }
  return 0;
};
/*-*/

/*-*/
const getTaxRentSavings = (amountResult, pointsResult, yourTaxRateResult, annualTaxResult, yearsBefore) => {
  // const pointsPercent = points / PERCENT_BASE;
  const taxResult = annualTaxResult * yourTaxRateResult * yearsBefore;
  const result = Math.abs(pointsResult + taxResult);
  console.log(annualTaxResult)
  return +result;
};
/*-*/

/*-*/
const getTotalRentSavings = (totalPaymentsBuyResult, totalPaymentsRentResult, taxSavingsBuyResult) => {
  const totalBuyResult = totalPaymentsBuyResult - taxSavingsBuyResult;
  const result = totalBuyResult - totalPaymentsRentResult;

  return +result.toFixed(3);
};
/*-*/

/*-*/

const getNewValue = (homeValueNew, annualAppreciationNew) => homeValueNew * annualAppreciationNew;
const getHouseAppreciationValue = (homeValue, yearsBefore, annualAppreciation) => {
  if (homeValue !== 0) {
    let newValue = 0;
    const annualAppreciationNew = annualAppreciation / PERCENT_BASE;
    let homeValueNew = homeValue;
    let counter = 0;
    while (counter < yearsBefore) {
      counter += 1;
      newValue = getNewValue(homeValueNew, annualAppreciationNew);
      homeValueNew += newValue;
    }
    return +homeValueNew;
  }
  return 0;
};

/*-*/

/*-*/
const getLoanBalance = (amountResult, monthlyPIResult, paymentsMonthResult, interestRateResult, monthTotal) => {
  if (interestRateResult !== 0) {
    let countMonth = 0;
    let amountResultNew = amountResult;

    while (countMonth < monthTotal) {
      countMonth += 1;
      const interestRateMonthlyResultNew = (amountResultNew * interestRateResult) / MONTH_IN_YEAR;
      const interest = interestRateMonthlyResultNew ?? 0;

      amountResultNew -= monthlyPIResult - interest;
      // console.log(amountResultNew)
    }

    return +amountResultNew;
  }
  return 0;
};
/*-*/

/*-*/
const getProceedsMinusCosts = (houseAppreciationValueResult, sellingCost) => {
  if (sellingCost !== 0) {
    const percentCost = sellingCost / PERCENT_BASE;
    const hoseCostDifference = houseAppreciationValueResult * percentCost;
    const result = houseAppreciationValueResult - hoseCostDifference;

    return +hoseCostDifference;
  }
  return 0;
};
/*-*/
const getProceedsMinusCostsForCalc = (houseAppreciationValueResult, sellingCost) => {
  if (sellingCost !== 0) {
    const percentCost = sellingCost / PERCENT_BASE;
    const hoseCostDifference = houseAppreciationValueResult * percentCost;
    const result = houseAppreciationValueResult - hoseCostDifference;

    return +result;
  }
  return 0;
};
/*-*/

/*-*/
// old
// const getEquityAppreciation = (proceedsMinusCostsResult, loanBalanceResult) => {
//   if (loanBalanceResult !== 0) {
//     const result = Math.abs(proceedsMinusCostsResult - loanBalanceResult);
//
//     return +result;
//   }
//   return 0;
// };
const getEquityAppreciation = (AMOUNT_RESULT, HOME_VALUE) => {
  // if (loanBalanceResult !== 0) {
    const result = HOME_VALUE - AMOUNT_RESULT;
    return +result;
  // }
};
/*-*/
/*-*/
const getClosingCostResult = (amount, pointsResult) => {
  // if (points !== 0) {
  //   const result = amount * (points / 100);
  //   return +result;
  // }
  return +pointsResult;
};
/*-*/

/*-*/
// old
// const getHomePurchaseBenefits = (equityAppreciationResult, totalRentSavingsResult) => {
//   if (totalRentSavingsResult !== 0) {
//     const result = equityAppreciationResult - totalRentSavingsResult;
//     return +result;
//   }
//   return 0;
// };

const getHomePurchaseBenefits = (proceedsMinusCostsResult, loanBalanceResult, equityAppreciationResult, closingCostResult) => {
  // if (total/RentSavingsResult !== 0) {
    const result = proceedsMinusCostsResult - loanBalanceResult - equityAppreciationResult - closingCostResult;
    return +result;
  // }
  // return 0;
};
/*-*/

/* -Calc-*/
const calc = (elements, watchedState) => {
  const { form, result } = watchedState;
  const { values, exclude } = form;

  // input values
  const MONTHLY_RENT = values['monthly-rent'];
  const RENT_INSURANCE = values['rental-insurance'];
  const ANNUAL_RENT_INCREASE = values['annual-rent-increase'];
  const ANNUAL_MAINTENANCE = values['annual-maintenance'];
  const ANNUAL_APPRECIATION = values['annual-appreciation'];
  const HOME_VALUE = values['home-value'];
  const YEARS_BEFORE = values['years-before'];
  const SELLING_COST = values['selling-cost'];
  const AMOUNT_RESULT = values.amount;
  const INTEREST_RATE = values['interest-rate'];
  const YOUR_TAX_RATE = values['your-tax-rate'];
  const ANNUAL_TAX = values['annual-tax'];
  const ANNUAL_INSURANCE = values['annual-insurance'];
  const ANNUAL_PMI = values['annual-pmi'];
  const HOA_DUES = values['hoa-dues'];
  const { term } = values;
  const { points } = values;

  // * switchers
  const SWITCH_TAX_RATE = exclude['switch-tax-rate'];
  const SWITCH_TAXES = exclude['switch-taxes'];
  const SWITCH_INSURANCE = exclude['switch-insurance'];
  const SWITCH_PMI = exclude['switch-pmi'];
  const SWITCH_RENTAL_INSURANCE = exclude['switch-rental-insurance'];
  const SWITCH_POINTS = exclude['switch-points'];

  // results calc
  const monthsTotal = +YEARS_BEFORE * MONTH_IN_YEAR;
  const pointsResult = getPoints(SWITCH_POINTS, AMOUNT_RESULT, points);
  const yourTaxRateResult = getAnnualTaxRate(YOUR_TAX_RATE, SWITCH_TAX_RATE);
  const annualTaxResult = getAnnualTax(ANNUAL_TAX, SWITCH_TAXES, HOME_VALUE);
  const annualTaxIncreaseResult = getAnnualTaxIncrease(ANNUAL_TAX, SWITCH_TAXES, HOME_VALUE, YEARS_BEFORE, ANNUAL_APPRECIATION);
  const annualInsuranceResult = getAnnualInsurance(ANNUAL_INSURANCE, SWITCH_INSURANCE, HOME_VALUE);
  /* - For month pmi --*/
  const loanValueRatioResult = getValueRatio(AMOUNT_RESULT, HOME_VALUE);
  const interestRateResult = getInterestRate(INTEREST_RATE);
  const paymentsMonthResult = +term * MONTH_IN_YEAR;
  const interestRateMonthlyResult = getInterestRateMonthly(INTEREST_RATE);
  const monthlyPIResult = getResMonthlyPI(AMOUNT_RESULT, interestRateMonthlyResult, paymentsMonthResult);
  const monthlyInterestResult = getResMonthlyInterest(AMOUNT_RESULT, interestRateResult);
  const annualPMIResult = getAnnualPMI(ANNUAL_PMI, SWITCH_PMI, AMOUNT_RESULT);
  const monthlyPMIResult = getMonthlyPMI(annualPMIResult, SWITCH_PMI, loanValueRatioResult, interestRateResult);
  const monthPMIResult = getMonthPMI(
    loanValueRatioResult,
    AMOUNT_RESULT,
    HOME_VALUE,
    monthlyPIResult,
    monthlyInterestResult,
    monthlyPMIResult,
    paymentsMonthResult,
    interestRateResult,
    interestRateMonthlyResult,
  );
  const monthlyTaxResult = getMonthlyTax(annualTaxResult, SWITCH_TAXES, AMOUNT_RESULT);
  const monthlyInsuranceResult = getMonthlyInsurance(annualInsuranceResult, SWITCH_INSURANCE, AMOUNT_RESULT);
  const monthlyPaymentResult = getResMonthlyPayment(
    AMOUNT_RESULT,
    interestRateMonthlyResult,
    paymentsMonthResult,
    monthlyTaxResult,
    monthlyInsuranceResult,
    monthlyPMIResult,
  );
  const differenceWithoutPmi = getDifferencePmi(monthsTotal, monthPMIResult, monthlyPMIResult, YEARS_BEFORE);
  /* -For month pmi--*/

  // part 1
  const taxesInsuranceRentResult = getRentInsurance(MONTHLY_RENT, RENT_INSURANCE, YEARS_BEFORE, SWITCH_RENTAL_INSURANCE);
  const taxesInsuranceBuyResult = getTaxesInsuranceBuy(annualTaxIncreaseResult, annualInsuranceResult, YEARS_BEFORE);
  const PMIRentResult = 0;
  // const PMIBuyResult = getPMIBuy(annualPMIResult, monthPMIResult);
  const PMIBuyResult = getPMIBuy(annualPMIResult, monthPMIResult, YEARS_BEFORE, AMOUNT_RESULT, monthlyPIResult, interestRateResult, loanValueRatioResult, HOME_VALUE, paymentsMonthResult);
  // const maintenanceRentResult = 0;
  const maintenanceBuyResult = getMaintenanceBuyResult(ANNUAL_MAINTENANCE, HOA_DUES, YEARS_BEFORE);
  const maintenanceRentResult = 0;

  const totalPaymentsRentResult = getTotalRent(YEARS_BEFORE, MONTHLY_RENT, ANNUAL_RENT_INCREASE, taxesInsuranceRentResult);
  const totalPaymentsBuyResult = getTotalBuy(
    monthlyPMIResult,
    monthlyPaymentResult,
    ANNUAL_MAINTENANCE,
    monthsTotal,
    differenceWithoutPmi,
    monthPMIResult,
    taxesInsuranceBuyResult
  );

  const totalPrincipalRent = getPrincipalRent(YEARS_BEFORE, MONTHLY_RENT, ANNUAL_RENT_INCREASE);
  const totalPrincipalBuy = getPrincipalBuy(totalPaymentsBuyResult, taxesInsuranceBuyResult, PMIBuyResult, maintenanceBuyResult);
  // part 2
  const averageMonthlyRentResult = getAverageMonthlyRent(totalPaymentsRentResult, monthsTotal);
  const averageMonthlyBuyResult = getAverageMonthlyBuy(totalPaymentsBuyResult, monthsTotal);
  const monthlyRentSavingsResult = getMonthlyRentSavings(averageMonthlyRentResult, averageMonthlyBuyResult);
  const taxSavingsRentResult = 0;
  const taxSavingsBuyResult = getTaxRentSavings(AMOUNT_RESULT, pointsResult, yourTaxRateResult, annualTaxResult, YEARS_BEFORE);
  const totalRentSavingsResult = getTotalRentSavings(
    totalPaymentsBuyResult,
    totalPaymentsRentResult,
    taxSavingsBuyResult,
  );

  // part 3
  const houseAppreciationValueResult = getHouseAppreciationValue(HOME_VALUE, YEARS_BEFORE, ANNUAL_APPRECIATION);
  const proceedsMinusCostsResult = getProceedsMinusCosts(houseAppreciationValueResult, SELLING_COST);
  const loanBalanceResult = getLoanBalance(
    AMOUNT_RESULT,
    monthlyPIResult,
    paymentsMonthResult,
    interestRateResult,
    monthsTotal,
  );
  const proceedsMinusCostsForCalc = getProceedsMinusCostsForCalc(houseAppreciationValueResult, SELLING_COST);
  // old
  // const equityAppreciationResult = getEquityAppreciation(proceedsMinusCostsResult, loanBalanceResult);
  const equityAppreciationResult = getEquityAppreciation(AMOUNT_RESULT, HOME_VALUE);
  const closingCostResult = getClosingCostResult(AMOUNT_RESULT, pointsResult);
  // old
  // const homePurchaseBenefitsResult = getHomePurchaseBenefits(equityAppreciationResult, totalRentSavingsResult);
  const homePurchaseBenefitsResult = getHomePurchaseBenefits(proceedsMinusCostsForCalc, loanBalanceResult, equityAppreciationResult, closingCostResult);

  // values output / details
  result['monthly-rent'] = setFixedNumber(MONTHLY_RENT);
  result['annual-rent-increase'] = setFixedNumber(ANNUAL_RENT_INCREASE);
  result['annual-maintenance'] = setFixedNumber(ANNUAL_MAINTENANCE);
  result['annual-appreciation'] = setFixedNumber(ANNUAL_APPRECIATION);
  result['home-value'] = setFixedNumber(HOME_VALUE);
  result['years-before'] = YEARS_BEFORE;
  result['selling-cost'] = setFixedNumber(SELLING_COST);
  result.amount = setFixedNumber(AMOUNT_RESULT);
  result['interest-rate'] = INTEREST_RATE;
  result.term = term;
  result.points = setFixedNumber(points);
  result['your-tax-rate'] = setFixedNumber(YOUR_TAX_RATE);
  result['annual-tax'] = setFixedNumber(annualTaxResult);
  result['annual-insurance'] = setFixedNumber(annualInsuranceResult);
  result['annual-pmi'] = setFixedNumber(ANNUAL_PMI);
  // new total monthly
  result['total-principal-rent'] = setFixedNumber(totalPrincipalRent);
  result['total-principal-buy'] = setFixedNumber(totalPrincipalBuy);
  result['taxes-insurance-rent'] = setFixedNumber(taxesInsuranceRentResult);
  result['taxes-insurance-buy'] = setFixedNumber(taxesInsuranceBuyResult);
  result['pmi-rent'] = setFixedNumber(PMIRentResult);
  result['pmi-buy'] = setFixedNumber(PMIBuyResult);
  result['maintenance-rent'] = setFixedNumber(maintenanceRentResult);
  result['maintenance-buy'] = setFixedNumber(maintenanceBuyResult);
  result['total-payments-rent'] = setFixedNumber(totalPaymentsRentResult);
  result['total-payments-buy'] = setFixedNumber(totalPaymentsBuyResult);
  result['average-monthly-rent'] = setFixedNumber(averageMonthlyRentResult);
  result['average-monthly-buy'] = setFixedNumber(averageMonthlyBuyResult);
  result['monthly-rent-savings'] = setFixedNumber(monthlyRentSavingsResult);
  result['tax-savings-rent'] = setFixedNumber(taxSavingsRentResult);
  result['tax-savings-buy'] = setFixedNumber(taxSavingsBuyResult);
  result['total-rent-savings'] = setFixedNumber(totalRentSavingsResult);
  result['house-appreciation-value'] = setFixedNumber(houseAppreciationValueResult);
  result['proceeds-minus-costs'] = setFixedNumber(proceedsMinusCostsResult);
  result['loan-balance'] = setFixedNumber(loanBalanceResult);
  result['equity-appreciation'] = setFixedNumber(equityAppreciationResult);
  result['closing-cost'] = setFixedNumber(closingCostResult);
  result['home-purchase-benefits'] = setFixedNumber(homePurchaseBenefitsResult);
};

export default calc;
